import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { AddColourApi } from "./Colour.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from 'lodash'
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddColour = (props) => {
  const [colourName, setColour] = useState("");
  const [colourDesc, setColourDesc] = useState("");

  function uploadColour() {
    props.AddColourApi({
      colourName: colourName,
      colourDesc: colourDesc,
    },
      showSuccessAlert,
      showErrorAlert
    );
    setColour("")
    setColourDesc("");
  }

  useEffect(() => {
    props.setHeading("Add Colour");
  }, []);

  return (
    <>
      {props.isAddingColour ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Colour Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Colour Name"
                  onChange={(e) => setColour(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Description </b></Form.Label>
                <Form.Control
                  type="text"
                  value={colourDesc}
                  placeholder="Colour Description"
                  onChange={(e) => setColourDesc(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(colourName) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadColour}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    AddColourApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddColourApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingColour: state.ColourReducer.isAddingColour,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddColour);